<template>
    <span class="inline-flex justify-center items-center mx-1">
        <template v-for="(color, idx_color) in options.colors">
            <span
                class="q10__triangle"
                :class="[color, 'triangle_direction_' + options.direction]"
                :key="idx_color"
                :style="{
                    borderColor: `transparent transparent transparent ${color}`,
                }"
            >
            </span>
        </template>
    </span>
</template>

<script>
export default {
    name: "Triangles",
    props: {
        options: null,
    },
};
</script>

<style lang="scss" scoped>
.q10__triangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7px 0 7px 12.1px;
    margin: 3px;
    &.triangle_direction_top {
        @apply transform -rotate-90;
    }
    &.triangle_direction_Desktop_left_Tablet_and_Mobile_top {
        @apply transform -rotate-90 xl:transform xl:rotate-180;
    }
    &.triangle_direction_bottom {
        @apply transform rotate-90;
    }
    &.triangle_direction_left {
        @apply transform rotate-180;
    }
    &.triangle_direction_right {
        @apply transform rotate-0;
    }
}
</style>
